import { createStyles, makeStyles } from '@material-ui/core';

export const useMobileDrawerStyles = makeStyles(() =>
    createStyles({
        root: {
            zIndex: 20000,
            position: 'fixed',
            padding: '16px 16px 8px',
            inset: 'auto 0px 0px 0px',
            backgroundColor: '#ffffff',
            borderRadius: '25px 25px 0px 0px'
        },
        backdrop: {
            inset: 0,
            zIndex: 19999,
            position: 'fixed',
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
        },
        chip: {
            width: 56,
            height: 6,
            display: 'block',
            borderRadius: 100,
            margin: '0 auto 24px',
            backgroundColor: '#D4D4D4'
        }
    })
);
